<template>
  <v-app  >
    <v-navigation-drawer v-model="drawer" app clipped v-bind:class="{ 'hidden': hidden }" >
      <v-list dense>
        <v-list-item-group  >
          <v-list-item to="/home" >
            <v-list-item-icon>
              <v-icon>home</v-icon>
            </v-list-item-icon>
            <v-list-item-content >
              <v-list-item-title v-text="'Home'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item to="/settings" >
            <v-list-item-icon>
              <v-icon>settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content >
              <v-list-item-title v-text="'Settings'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar color="primary" dense dark app clipped-left v-bind:class="{ 'hidden': hidden }">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Home</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="logout" icon><v-icon>exit_to_app</v-icon></v-btn>
    </v-app-bar>
    <div class="content1">
        <slot></slot>
        <slot name="other"></slot>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "NavigationMenu",
  data: () => ({
    drawer: true,
    boards: [],
    addBoard: null
  }),
  methods: {
    logout() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.console.log("{ name: 'Login' }");
      this.$router.push({ name: 'Login' });
    }
  },
  props: {
    source: String,
    hidden: Boolean
  },
  created() {
    if(this.hidden)
      return;
  }
};
</script>


<style scoped>

.content1 {
  height: 100vh;
  padding-top: 57px;
}

@media (max-width: 2560px) {
  .content1 {
      margin: 0 0 0 300px;
      width: 1690px;
  }
}

@media (max-width: 1920px) {
  .content1 {
      margin: 0 0 0 300px;
      width: 1269px;
  }
}

@media (max-width: 1440px) {
  .content1 {
      margin: 0 0 0 300px;
      width: 1100px;
  }
}

@media (max-width: 1024px) {
  .content1 {
      margin: 0 0 0 0px;
      width: 1000px;
  }
}

@media (max-width: 768px) {
  .content1 {
      margin: 0 0 0 0px;
      width: 100%;
  }
}
  
</style>